/* =========================================================
   Puddi Shuffle — shared shuffle-bag utility
   Exposes window.PuddiShuffle for use across sections.

   Loaded globally from layout/theme.liquid ahead of section
   scripts so any section can call it without importing.

   Why this exists:
     Any copy pool visible over time (bubbles, guarantee stamp,
     Puddi math, empty-cart headline, trust signals) reads as
     robotic on the second visit if the sequence is detectable.
     This utility gives every rotator random opening lines,
     no dupes within a shuffled pass, and no back-to-back
     repeats at the shuffle seam — one code path, everywhere.

   Two APIs:

     PuddiShuffle.shuffle(arr)
       Fisher-Yates. Returns a new shuffled copy of `arr`.
       For one-off picks:  shuffle(TRUST).slice(0, 2)

     PuddiShuffle.createDeck(pool, opts)
       Stateful walking deck. Returns { draw }.
       Each draw() returns the next line from a shuffled pass
       through `pool`. When the pass is exhausted, the pool is
       reshuffled with a seam guard so the head of the new deck
       cannot repeat any of the last `recentSize` drawn OR any
       items currently reported by `getVisible()`.

       opts:
         recentSize:  N (default 3) — block last N drawn against
                                       the head of the next shuffle
         getVisible:  () => Set     — optional; called at reshuffle
                                       time. Any items returned are
                                       also blocked from the head of
                                       the next deck.
   ========================================================= */

(function () {
  'use strict';

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function createDeck(pool, opts) {
    opts = opts || {};
    var recentSize = opts.recentSize != null ? opts.recentSize : 3;
    var getVisible = opts.getVisible;

    var deck = shuffle(pool);
    var idx = 0;
    var recent = [];

    function draw() {
      if (idx >= deck.length) {
        var next = shuffle(pool);
        var blocked = new Set(recent);
        if (getVisible) {
          var vis = getVisible();
          if (vis && vis.forEach) vis.forEach(function (l) { blocked.add(l); });
        }
        var guardN = Math.min(blocked.size, next.length);
        for (var i = 0; i < guardN; i++) {
          if (!blocked.has(next[i])) continue;
          for (var j = i + 1; j < next.length; j++) {
            if (!blocked.has(next[j])) {
              var t = next[i]; next[i] = next[j]; next[j] = t;
              break;
            }
          }
        }
        deck = next;
        idx = 0;
      }
      var line = deck[idx++];
      recent.push(line);
      if (recent.length > recentSize) recent.shift();
      return line;
    }

    return { draw: draw };
  }

  window.PuddiShuffle = {
    shuffle: shuffle,
    createDeck: createDeck
  };
})();
